module.exports = __webpack_public_path__ + "static/media/design-ripped-off.23bd9d74.svg";